import React, { createContext, useContext, useState, useEffect } from 'react';
import { getProfile, saveProfile, getFullGreeting } from '../services/profileService';

const ProfileContext = createContext(undefined);

export function ProfileProvider({ children }) {
  const [profile, setProfile] = useState(null);
  const [greeting, setGreeting] = useState('');

  useEffect(() => {
    // Load profile on mount
    const savedProfile = getProfile();
    if (savedProfile) {
      setProfile(savedProfile);
    }
    updateGreeting();
    
    // Update greeting every minute
    const interval = setInterval(updateGreeting, 60000);
    return () => clearInterval(interval);
  }, []);

  const updateGreeting = () => {
    setGreeting(getFullGreeting());
  };

  const updateProfile = (newProfile) => {
    const success = saveProfile(newProfile);
    if (success) {
      setProfile(newProfile);
      updateGreeting();
      return true;
    }
    return false;
  };

  const value = {
    profile,
    greeting,
    updateProfile,
    isProfileSet: !!profile?.name,
  };

  return (
    <ProfileContext.Provider value={value}>
      {children}
    </ProfileContext.Provider>
  );
}

export function useProfile() {
  const context = useContext(ProfileContext);
  if (context === undefined) {
    throw new Error('useProfile must be used within a ProfileProvider');
  }
  return context;
}